import React from "react";
import classnames from "classnames";
import { observer } from "mobx-react";

import { IDeviceDetails } from "@formant/core/model/IDeviceDetails";
import { Icon } from "@formant/ui/component/common/Icon";

import { useRouter } from "../../../context/RouterContext";
import { useStores } from "../../../context/StoreContext";
import { Button } from "../../common/Button";
import * as styles from "./DeviceButton.scss";

export interface IDeviceButtonProps {
    device: IDeviceDetails;
}

export const DeviceButton = observer(function DeviceButton(
    props: IDeviceButtonProps,
) {
    const {
        device: { name, id },
    } = props;
    const { onlineDevicesStore } = useStores();
    const { routeTo } = useRouter();

    if (!id) {
        return null;
    }

    const isOnline = onlineDevicesStore.isOnline(id);

    return (
        <Button
            className={classnames(styles["device-button"], styles.button)}
            to={routeTo.device({ id })}
            data-tooltip="Return to device view"
            data-testid="teleop-device-button"
        >
            <div
                className={classnames(
                    styles["icon-container"],
                    isOnline && styles.online,
                )}
            >
                <Icon name="device" className={styles.icon} color="black" />
            </div>

            <div className={styles.name}>{name}</div>
        </Button>
    );
});
